export interface Circle {
  cx: string
  cy: string
  r: string
  type: string
}

const circles: Circle[] = [
  { cx: '126.36', cy: '101.1', r: '8', type: 'other' },
  { cx: '144.66', cy: '119.5', r: '8', type: 'other' },
  { cx: '163.06', cy: '137.9', r: '8', type: 'other' },
  { cx: '185.56', cy: '152.9', r: '8', type: 'other' },
  { cx: '123.16', cy: '69.6', r: '8', type: 'other' },
  { cx: '141.66', cy: '88.2', r: '8', type: 'other' },
  { cx: '160.06', cy: '106.8', r: '8', type: 'other' },
  { cx: '178.56', cy: '125.4', r: '8', type: 'other' },
  { cx: '139.26', cy: '57.7', r: '8', type: 'other' },
  { cx: '214.06', cy: '164', r: '8', type: 'other' },
  { cx: '157.86', cy: '76.5', r: '8', type: 'other' },
  { cx: '202.16', cy: '140.7', r: '8', type: 'other' },
  { cx: '176.56', cy: '95.4', r: '8', type: 'other' },
  { cx: '195.26', cy: '114.4', r: '8', type: 'other' },
  { cx: '156.16', cy: '46.9', r: '8', type: 'other' },
  { cx: '174.96', cy: '66.1', r: '8', type: 'other' },
  { cx: '193.86', cy: '85.5', r: '8', type: 'other' },
  { cx: '220.06', cy: '130.5', r: '8', type: 'other' },
  { cx: '173.86', cy: '37.3', r: '8', type: 'other' },
  { cx: '233.76', cy: '152.7', r: '8', type: 'other' },
  { cx: '212.86', cy: '105.1', r: '8', type: 'other' },
  { cx: '192.86', cy: '57', r: '8', type: 'other' },
  { cx: '192.06', cy: '29', r: '8', type: 'other' },
  { cx: '212.06', cy: '77.1', r: '8', type: 'other' },
  { cx: '211.36', cy: '49.4', r: '8', type: 'other' },
  { cx: '239.06', cy: '122.4', r: '8', type: 'other' },
  { cx: '231.26', cy: '97.5', r: '8', type: 'other' },
  { cx: '210.96', cy: '22.1', r: '8', type: 'other' },
  { cx: '230.86', cy: '70.3', r: '8', type: 'other' },
  { cx: '254.96', cy: '144.5', r: '8', type: 'other' },
  { cx: '230.46', cy: '43.3', r: '8', type: 'other' },
  { cx: '230.16', cy: '16.5', r: '8', type: 'other' },
  { cx: '250.36', cy: '91.8', r: '8', type: 'other' },
  { cx: '258.86', cy: '116.5', r: '8', type: 'other' },
  { cx: '250.16', cy: '65.2', r: '8', type: 'other' },
  { cx: '249.96', cy: '38.6', r: '8', type: 'other' },
  { cx: '249.76', cy: '12.2', r: '8', type: 'other' },
  { cx: '277.06', cy: '139.5', r: '8', type: 'other' },
  { cx: '269.96', cy: '88', r: '8', type: 'other' },
  { cx: '269.86', cy: '61.7', r: '8', type: 'other' },
  { cx: '269.76', cy: '35.5', r: '8', type: 'other' },
  { cx: '279.16', cy: '113', r: '8', type: 'other' },
  { cx: '269.66', cy: '9.4', r: '8', type: 'other' },
  { cx: '289.76', cy: '86', r: '8', type: 'other' },
  { cx: '289.76', cy: '60', r: '8', type: 'other' },
  { cx: '289.66', cy: '34', r: '8', type: 'other' },
  { cx: '289.66', cy: '8', r: '8', type: 'other' },
  { cx: '299.76', cy: '137.8', r: '8', type: 'other' },
  { cx: '299.76', cy: '111.8', r: '8', type: 'other' },
  { cx: '309.76', cy: '8', r: '8', type: 'other' },
  { cx: '309.76', cy: '34', r: '8', type: 'other' },
  { cx: '309.76', cy: '60', r: '8', type: 'other' },
  { cx: '309.66', cy: '86', r: '8', type: 'other' },
  { cx: '329.76', cy: '9.4', r: '8', type: 'other' },
  { cx: '320.26', cy: '113', r: '8', type: 'other' },
  { cx: '329.66', cy: '35.5', r: '8', type: 'other' },
  { cx: '329.66', cy: '61.7', r: '8', type: 'other' },
  { cx: '329.56', cy: '88', r: '8', type: 'other' },
  { cx: '322.36', cy: '139.5', r: '8', type: 'other' },
  { cx: '349.66', cy: '12.2', r: '8', type: 'other' },
  { cx: '349.46', cy: '38.6', r: '8', type: 'other' },
  { cx: '349.36', cy: '65.2', r: '8', type: 'other' },
  { cx: '340.66', cy: '116.5', r: '8', type: 'other' },
  { cx: '349.06', cy: '91.8', r: '8', type: 'other' },
  { cx: '369.26', cy: '16.5', r: '8', type: 'other' },
  { cx: '368.96', cy: '43.3', r: '8', type: 'other' },
  { cx: '344.56', cy: '144.5', r: '8', type: 'other' },
  { cx: '368.66', cy: '70.3', r: '8', type: 'other' },
  { cx: '388.56', cy: '22.1', r: '8', type: 'other' },
  { cx: '368.16', cy: '97.5', r: '8', type: 'other' },
  { cx: '360.36', cy: '122.4', r: '8', type: 'other' },
  { cx: '388.06', cy: '49.4', r: '8', type: 'other' },
  { cx: '387.46', cy: '77.1', r: '8', type: 'other' },
  { cx: '407.36', cy: '29', r: '8', type: 'other' },
  { cx: '406.56', cy: '57', r: '8', type: 'other' },
  { cx: '386.56', cy: '105.1', r: '8', type: 'other' },
  { cx: '365.66', cy: '152.7', r: '8', type: 'other' },
  { cx: '425.66', cy: '37.3', r: '8', type: 'other' },
  { cx: '379.36', cy: '130.5', r: '8', type: 'other' },
  { cx: '405.56', cy: '85.5', r: '8', type: 'other' },
  { cx: '424.46', cy: '66.1', r: '8', type: 'other' },
  { cx: '443.26', cy: '46.9', r: '8', type: 'other' },
  { cx: '404.26', cy: '114.4', r: '8', type: 'other' },
  { cx: '422.96', cy: '95.4', r: '8', type: 'other' },
  { cx: '397.26', cy: '140.7', r: '8', type: 'other' },
  { cx: '441.56', cy: '76.5', r: '8', type: 'other' },
  { cx: '385.36', cy: '164', r: '8', type: 'other' },
  { cx: '460.16', cy: '57.7', r: '8', type: 'other' },
  { cx: '420.86', cy: '125.4', r: '8', type: 'other' },
  { cx: '439.36', cy: '106.8', r: '8', type: 'other' },
  { cx: '457.86', cy: '88.2', r: '8', type: 'other' },
  { cx: '476.26', cy: '69.6', r: '8', type: 'other' },
  { cx: '413.86', cy: '152.9', r: '8', type: 'other' },
  { cx: '436.36', cy: '137.9', r: '8', type: 'other' },
  { cx: '454.76', cy: '119.5', r: '8', type: 'other' },
  { cx: '473.16', cy: '101.1', r: '8', type: 'other' },
  { cx: '403.26', cy: '178.1', r: '8', type: 'other' },
  { cx: '491.56', cy: '82.7', r: '8', type: 'other' },
  { cx: '428.96', cy: '166.9', r: '8', type: 'other' },
  { cx: '505.76', cy: '96.8', r: '8', type: 'other' },
  { cx: '487.36', cy: '115.2', r: '8', type: 'other' },
  { cx: '468.96', cy: '133.6', r: '8', type: 'other' },
  { cx: '450.56', cy: '151.9', r: '8', type: 'other' },
  { cx: '519.07', cy: '111.89', r: '8', type: 'other' },
  { cx: '418.76', cy: '194.7', r: '8', type: 'other' },
  { cx: '500.46', cy: '130.3', r: '8', type: 'other' },
  { cx: '481.96', cy: '148.8', r: '8', type: 'other' },
  { cx: '442.36', cy: '182.6', r: '8', type: 'other' },
  { cx: '463.26', cy: '167.2', r: '8', type: 'other' },
  { cx: '531.16', cy: '127.9', r: '8', type: 'other' },
  { cx: '512.36', cy: '146.5', r: '8', type: 'other' },
  { cx: '542.06', cy: '144.7', r: '8', type: 'other' },
  { cx: '80.16', cy: '219', r: '8', type: 'ge' },
  { cx: '31.96', cy: '199.2', r: '8', type: 'ge' },
  { cx: '107.56', cy: '219.5', r: '8', type: 'ge' },
  { cx: '59.46', cy: '199.7', r: '8', type: 'ge' },
  { cx: '39.16', cy: '180.4', r: '8', type: 'ge' },
  { cx: '87.16', cy: '200.3', r: '8', type: 'ge' },
  { cx: '67.26', cy: '181.2', r: '8', type: 'ge' },
  { cx: '115.36', cy: '201.2', r: '8', type: 'ge' },
  { cx: '47.56', cy: '162.2', r: '8', type: 'ge' },
  { cx: '95.76', cy: '182.3', r: '8', type: 'ge' },
  { cx: '76.46', cy: '163.5', r: '8', type: 'ge' },
  { cx: '57.36', cy: '144.7', r: '8', type: 'ge' },
  { cx: '157.76', cy: '233.7', r: '8', type: 'ro' },
  { cx: '136.16', cy: '218.1', r: '8', type: 'ro' },
  { cx: '167.76', cy: '213.4', r: '8', type: 'ro' },
  { cx: '145.56', cy: '199.7', r: '8', type: 'ro' },
  { cx: '124.96', cy: '183.7', r: '8', type: 'ro' },
  { cx: '105.96', cy: '165.1', r: '8', type: 'ro' },
  { cx: '87.06', cy: '146.5', r: '8', type: 'ro' },
  { cx: '68.26', cy: '127.9', r: '8', type: 'ro' },
  { cx: '136.16', cy: '167.2', r: '8', type: 'ro' },
  { cx: '157.06', cy: '182.6', r: '8', type: 'ro' },
  { cx: '117.56', cy: '148.8', r: '8', type: 'ro' },
  { cx: '98.96', cy: '130.3', r: '8', type: 'ro' },
  { cx: '180.66', cy: '194.7', r: '8', type: 'ro' },
  { cx: '80.46', cy: '111.9', r: '8', type: 'ro' },
  { cx: '148.86', cy: '151.9', r: '8', type: 'ro' },
  { cx: '130.46', cy: '133.6', r: '8', type: 'ro' },
  { cx: '112.06', cy: '115.2', r: '8', type: 'ro' },
  { cx: '93.66', cy: '96.8', r: '8', type: 'ro' },
  { cx: '170.46', cy: '166.9', r: '8', type: 'ro' },
  { cx: '107.96', cy: '82.7', r: '8', type: 'ro' },
  { cx: '196.26', cy: '178.1', r: '8', type: 'ro' },
  { cx: '17.06', cy: '277.8', r: '8', type: 'vd' },
  { cx: '43.06', cy: '277.8', r: '8', type: 'vd' },
  { cx: '69.06', cy: '277.8', r: '8', type: 'vd' },
  { cx: '95.16', cy: '277.8', r: '8', type: 'vd' },
  { cx: '121.16', cy: '277.8', r: '8', type: 'vd' },
  { cx: '147.26', cy: '277.8', r: '8', type: 'vd' },
  { cx: '18.66', cy: '257.8', r: '8', type: 'vd' },
  { cx: '44.86', cy: '257.8', r: '8', type: 'vd' },
  { cx: '71.06', cy: '257.9', r: '8', type: 'vd' },
  { cx: '97.36', cy: '258', r: '8', type: 'vd' },
  { cx: '123.86', cy: '257.4', r: '8', type: 'vd' },
  { cx: '21.66', cy: '238', r: '8', type: 'vd' },
  { cx: '48.16', cy: '238.1', r: '8', type: 'vd' },
  { cx: '74.76', cy: '238.3', r: '8', type: 'vd' },
  { cx: '150.86', cy: '255.4', r: '8', type: 'vd' },
  { cx: '101.46', cy: '238.5', r: '8', type: 'vd' },
  { cx: '26.16', cy: '218.4', r: '8', type: 'vd' },
  { cx: '53.06', cy: '218.7', r: '8', type: 'vd' },
  { cx: '128.86', cy: '237.4', r: '8', type: 'vd' },
  { cx: '493.56', cy: '165.1', r: '8', type: 'zu' },
  { cx: '474.56', cy: '183.7', r: '8', type: 'zu' },
  { cx: '453.86', cy: '199.7', r: '8', type: 'zu' },
  { cx: '431.66', cy: '213.4', r: '8', type: 'zu' },
  { cx: '522.96', cy: '163.5', r: '8', type: 'zu' },
  { cx: '503.66', cy: '182.3', r: '8', type: 'zu' },
  { cx: '551.86', cy: '162.2', r: '8', type: 'zu' },
  { cx: '484.06', cy: '201.2', r: '8', type: 'zu' },
  { cx: '532.16', cy: '181.2', r: '8', type: 'zu' },
  { cx: '463.26', cy: '218.1', r: '8', type: 'zu' },
  { cx: '512.26', cy: '200.3', r: '8', type: 'zu' },
  { cx: '560.36', cy: '180.4', r: '8', type: 'zu' },
  { cx: '441.66', cy: '233.7', r: '8', type: 'zu' },
  { cx: '540.06', cy: '199.7', r: '8', type: 'zu' },
  { cx: '491.96', cy: '219.5', r: '8', type: 'zu' },
  { cx: '567.46', cy: '199.2', r: '8', type: 'zu' },
  { cx: '519.31', cy: '219.08', r: '8', type: 'zu' },
  { cx: '470.56', cy: '237.4', r: '8', type: 'zu' },
  { cx: '546.36', cy: '218.7', r: '8', type: 'zu' },
  { cx: '573.26', cy: '218.4', r: '8', type: 'zu' },
  { cx: '497.96', cy: '238.5', r: '8', type: 'zu' },
  { cx: '448.56', cy: '255.4', r: '8', type: 'zu' },
  { cx: '524.66', cy: '238.3', r: '8', type: 'zu' },
  { cx: '551.26', cy: '238.1', r: '8', type: 'zu' },
  { cx: '577.76', cy: '238', r: '8', type: 'zu' },
  { cx: '475.56', cy: '257.4', r: '8', type: 'zu' },
  { cx: '502.06', cy: '258', r: '8', type: 'zu' },
  { cx: '528.36', cy: '257.9', r: '8', type: 'zu' },
  { cx: '554.56', cy: '257.8', r: '8', type: 'zu' },
  { cx: '580.76', cy: '257.8', r: '8', type: 'zu' },
  { cx: '452.16', cy: '277.8', r: '8', type: 'zu' },
  { cx: '478.26', cy: '277.8', r: '8', type: 'zu' },
  { cx: '504.36', cy: '277.8', r: '8', type: 'zu' },
  { cx: '530.36', cy: '277.8', r: '8', type: 'zu' },
  { cx: '556.36', cy: '277.8', r: '8', type: 'zu' },
  { cx: '582.46', cy: '277.8', r: '8', type: 'zu' },
]

const typeCounters: { [key: string]: number } = {}

export const circlesData = circles.map((item) => {
  // Si le type de l'item n'est pas encore dans typeCounters, l'initialiser à 0
  if (!(item.type in typeCounters)) {
    typeCounters[item.type] = 0
  }

  // Créer un nouvel objet basé sur l'item original,
  // mais avec une propriété idType supplémentaire
  const newItem = {
    ...item,
    idType: typeCounters[item.type],
  }

  // Incrémenter le compteur pour le type de cet item
  typeCounters[item.type]++

  return newItem
})
